module.exports = __webpack_public_path__ + "static/media/Election Hockey.8e344e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Election Hockey.png
// module id = 669
// module chunks = 0